import Pusher from "pusher-js"
import Echo from "laravel-echo"

import {useEffect} from "react"

import {useDispatch, useSelector} from "react-redux"
import {useRecoilState} from "recoil"

import {DialogWrapper, FetchWrapper} from "@asset/FetchWrapper"
import {authAtom} from "@asset/AuthWrapper"

import _paths from "@src/_api"

window.Pusher = Pusher

const echo = new Echo({
    broadcaster: "reverb",
    key: process.env.REACT_APP_REVERB_APP_KEY,
    wsHost: process.env.REACT_APP_REVERB_HOST,
    wsPort: process.env.REACT_APP_REVERB_PORT,
    wssPort: process.env.REACT_APP_REVERB_PORT,
    // wsPath: '/websocket',
    forceTLS: true,
    enabledTransports: ["ws", "wss"]
    // forceTLS: false,
    // enabledTransports: ["ws"]
})

const AppPusher = () => {
    const dispatch = useDispatch()
    const spiderMan = useSelector(state => state.spiderman)
    const [auth] = useRecoilState(authAtom)

    const fetchWrapper = FetchWrapper()
    const dialog = DialogWrapper()

    useEffect(() => {
        if (!auth?.token) return
        if (!['admin', 'manager', 'engineer'].includes(auth.user.provider)) return

        if (!spiderMan)
            fetchWrapper.get(_paths.crawler.spiderman).then()

        echo.channel("api-rest-channel").listen(".afisz.spiderman", (event) => {
            console.log(".afisz.spiderman")
            if (event.data.name) {
                dialog.info("Beggining of new Era, we have new SpiderMan! Glory to " + event.data.name + "!")
                localStorage.setItem("spiderman", JSON.stringify(event.data))
                dispatch({type: "set", spiderman: event.data})
            } else if (spiderMan) {
                fetchWrapper.post(_paths.crawler.spiderman, {id: spiderMan.id, date: spiderMan.date}).then()
            }
        })
    }, [auth])

    useEffect(() => {
        echo.channel("api-rest-channel").listen(".afisz.notify", (event) => {
            console.log(".afisz.notify")
            localStorage.setItem("notify", JSON.stringify(event.data))
            dispatch({type: "set", notify: event.data})
        })

        echo.channel("api-rest-channel").listen(".afisz.hint", (event) => {
            console.log(".afisz.hint")
            localStorage.setItem("hint", JSON.stringify(event.data))
            dispatch({type: "set", hint: event.data})
        })
    }, []);

    useEffect(() => {
        if (!auth?.token) return

        const channel = echo.channel("api-rest-channel")

        channel.listen(".afisz.log", (event) => {
            console.log(".afisz.log")
            event.data.new = true

            let notifications = JSON.parse(localStorage.getItem("notifications"))
            if (notifications) {
                //Show notification
                dialog.info(event.data.message)

                //Add new notification
                notifications.push(event.data)

                //Save notifications
                localStorage.setItem("notifications", JSON.stringify(notifications))
            } else localStorage.setItem("notifications", JSON.stringify([event.data]))

            //Count new notifications
            dispatch({type: "set", asideCount: notifications.filter((n) => n.new).length})
        })

        channel.listen(".afisz.pretenses.province", (event) => {
            console.log(".afisz.pretenses.province")
            localStorage.setItem("workingOfPretense", JSON.stringify(event.data))
        })

        auth?.user?.id && channel.listen(".afisz.pretenses.stats." + auth.user.id, (event) => {
            console.log(".afisz.pretenses.stats." + auth.user.id)
            localStorage.setItem("statPretenses", JSON.stringify(event.data))
        })
    }, [auth])
}

export default AppPusher
